<template>
	<header class="header">
		<Nav></Nav>
		<div class="content">
			<h3>我们用心让客户更放心</h3>
			<p>源码交付 &nbsp; | &nbsp; 高质上线 &nbsp; | &nbsp; 售后无忧</p>
		</div>
	</header>
	<div class="serve">
		<h3>高品质行业服务</h3>
		<p>为企业提供一站式技术服务，以高品质铸造商业价值</p>
		<div class="content">
			<div class="box" @mouseenter="serveMouse(1)" :class="{
          dianshang: serveStatus && serveIndex == 1,
        }">
				<div class="top">
					<h4>小程序商城</h4>
				</div>
				<div class="buttom">
					<p><span>·</span> 3步开通一键发布</p>
					<p><span>·</span> 自定义+可视化店铺装修</p>
					<p><span>·</span> 分销+拼团+砍价+秒杀+优惠券</p>
					<p><span>·</span> 助力商家快速抢占社交电商市场先机</p>
					<div class="heng"></div>
				</div>
			</div>
			<div class="box" @mouseenter="serveMouse(2)" :class="{
          weixin: serveStatus && serveIndex == 2,
        }">
				<div class="top">
					<h4>APP开发</h4>
				</div>
				<div class="buttom">
					<p><span>·</span> IOS开发</p>
					<p><span>·</span> Android开发</p>
					<p><span>·</span> 物联网应用开发</p>
					<p><span>·</span> 等一站式APP开发服务</p>
					<div class="heng"></div>
				</div>
			</div>
			<div class="box" @mouseenter="serveMouse(3)" :class="{
          app: serveStatus && serveIndex == 3,
        }">
				<div class="top">
					<h4>网站建设</h4>
				</div>
				<div class="buttom">
					<p><span>·</span> 企业官网</p>
					<p><span>·</span> 营销型网站</p>
					<p><span>·</span> 响应式网站</p>
					<p><span>·</span> 助力企业在全面展示品牌优势</p>
					<div class="heng"></div>
				</div>
			</div>
			<div class="box" @mouseenter="serveMouse(4)" :class="{
          wangzhan: serveStatus && serveIndex == 4,
        }">
				<div class="top">
					<h4>微信小程序开发</h4>
				</div>
				<div class="buttom">
					<p><span>·</span> 小程序定制开发</p>
					<p><span>·</span> 公众号定制开发</p>
					<p><span>·</span> H5营销活动开发</p>
					<p><span>·</span> 助力获取微信流量红利</p>
					<div class="heng"></div>
				</div>
			</div>
		</div>
	</div>
	<div class="safety">
		<h3>安全可靠，全程技术支持</h3>
		<p>为全行业提供高效便捷得的小程序开发服务</p>
		<div class="content">
			<div class="box">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/jiashu.png" alt="" />
				<h4>加速应用开发<br />极致性体验</h4>
				<div class="heng"></div>
				<p>
					强大的Native渲染引擎提供丰富的API。出色的原生性和流畅的页面交互，为您的用户提供最佳的使用体验。
				</p>
			</div>
			<div class="box">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/keshi.png" alt="" />
				<h4>可视化开发<br />生成专业级源代码</h4>
				<div class="heng"></div>
				<p>
					通过可视化拖拉拽快递构建应用程序，一键生成专业及应用代码，开发者可直接二次开发使用。
				</p>
			</div>
			<div class="box">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/yitao.png" alt="" />
				<h4>一套代码<br />适配多端应用</h4>
				<div class="heng"></div>
				<p>
					只需一次作业，使用HTML5技术同时发布为Android、IOS、小程序、HTML5多端应用，使企业更专注于业务创新。
				</p>
			</div>
		</div>
	</div>
	<div class="chuangye">
		<h3>移动互联网创业-企业数字化转型</h3>
		<p>
			众多知名企业的放心之选，以专业的技术，成熟的行业经验，为企业提供高效可靠的移动化服务
		</p>
		<div class="content">
			<div class="kaifa">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/kaifalogo.png" alt="" />
				<p>小程序开发</p>
				<div class="xian"></div>
			</div>
			<div class="yunkaifa">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/yunkaifalogo.png" alt="" />
				<p>可视化云开发</p>
				<div class="xian"></div>
			</div>
			<div class="cesi">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/cesilogo.png" alt="" />
				<p>小程序测试</p>
				<div class="xian"></div>
			</div>
			<div class="fabu">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/fabulogo.png" alt="" />
				<p>小程序发布</p>
				<div class="xian"></div>
			</div>
			<div class="yunying">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/yunkaifalogo.png" alt="" />
				<p>应用运营</p>
				<div class="xian"></div>
			</div>
		</div>
	</div>
	<div class="liucheng">
		<h3>开发流程</h3>
		<p>高规格流程把控，保障优质产品输出</p>
		<div class="content">
			<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/liuchenglogo.png" alt="" />
		</div>
	</div>
	<div class="youshi">
		<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/youshilogo.png" alt="" />
		<div class="left">
			<h3>全行业小程序开发服务</h3>
			<p>
				· 众多知名企业的放心之选，以专业的技术、成熟的行业经验<br />&nbsp;
				为企业提供高效可靠的移动化服务
			</p>
			<p>· 15年移动开发经验，自有平台技术支持App/小程序同时开发，升级成本低</p>
			<p>
				· 支持移动应用定制、小程序开发、业务系统开发、行业解决方案等，<br />&nbsp;
				推动企业的创新发 展与数智化升级
			</p>
			<!-- <button @click="toConsult">免费小程序开发评估</button> -->
			
			<a onclick="openZoosUrl('chatwin')">免费小程序开发评估</a>
			
		</div>
	</div>
	<div class="cases">
		<div class="content">
			<div class="left">
				<h3>企业成功案例</h3>
				<p>
					君和数字创意帮助用户在移动场景中快速落地，涵盖电商、新能源、教育、社交、金融、资讯、医疗等众多领域
				</p>
				<a href="#">更多行业案例 &nbsp; ></a>
			</div>
			<div class="right">
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/case1.png" alt="" />
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/case2.png" alt="" />
				<img src="https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/4.png" alt="" />
			</div>
		</div>
	</div>
	<div class="apply">
		<h3>更多小程序行业案例，快速构建企业级应用</h3>
		<p>企业移动信息化转型，互联网创业快速落地</p>
		<!-- <button @click="toConsult">免费评估</button> -->
		
		<a onclick="openZoosUrl('chatwin')">免费评估</a>
	</div>
	<Onlineservice></Onlineservice>
	<Footer></Footer>
	<Floating></Floating>
</template>

<script>
	import Nav from "../Nav.vue";
	import Footer from "../Footer.vue";
	import Floating from "../Floating.vue";
	import Onlineservice from "../Onlineservice.vue"
	export default {
		name: "Serve",
		components: {
			Nav,
			Footer,
			Floating,
			Onlineservice
		},
		data() {
			return {
				serveIndex: 1,
				serveStatus: true,
			};
		},
		methods: {
			serveMouse(i) {
				this.serveIndex = i;
			},
			toConsult() {
				window.open(
					"https://wt.zoosnet.net/LR/Chatpre.aspx?id=LRW51906172&lng=cn&e=%e5%bc%b9%e7%aa%97",
					"_blank"
				);
			},
		},
	};
</script>

<style lang="less" scoped>
	.header {
		width: 100%;
		height: 520px;
		background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/servebg.png) no-repeat;
		background-size: cover;

		.content {
			width: 1440px;
			height: 400px;
			margin: 0 auto;
			/* background-color: white; */
			overflow: hidden;
			color: white;

			h3 {
				height: 50px;
				line-height: 50px;
				font-size: 36px;
				margin-top: 100px;
				font-weight: 540;
			}

			p {
				height: 50px;
				line-height: 50px;
				font-size: 22px;
				margin-top: 20px;
				font-weight: 400;
			}
		}
	}

	.serve {
		width: 100%;
		height: 965px;
		overflow: hidden;

		h3 {
			width: 1000px;
			height: 50px;
			font-size: 36px;
			font-weight: 500;
			color: #000000;
			line-height: 50px;
			margin: 0 auto;
			text-align: center;
			margin-top: 100px;
		}

		p {
			width: 1000px;
			height: 30px;
			font-size: 16px;
			font-weight: 400;
			color: #000000;
			line-height: 30px;
			margin: 0 auto;
			margin-top: 28px;
			text-align: center;
		}

		.content {
			width: 1440px;
			height: 600px;
			margin: 0 auto;
			display: flex;
			justify-content: space-around;
			align-items: center;
			margin-top: 60px;

			.box {
				width: 350px;
				height: 530px;
				transition: all 0.5s;

				.top {
					overflow: hidden;
					width: 350px;
					height: 350px;
					background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/box1.png) no-repeat;
					background-size: cover;
					border-radius: 5px 5px 0 0;

					h4 {
						width: 300px;
						height: 50px;
						font-size: 30px;
						font-weight: 500;
						color: #ffffff;
						line-height: 50px;
						margin: 50px 0 0 30px;
					}
				}

				.buttom {
					width: 350px;
					height: 180px;
					background: #f5f7f9;
					overflow: hidden;
					padding-top: 30px;

					p {
						width: 300px;
						height: 30px;
						font-size: 16px;
						font-weight: 400;
						color: #000000;
						line-height: 30px;
						text-align: left;
						margin-top: 0px;
					}

					.heng {
						width: 300px;
						height: 2px;
						background: #fe0000;
						box-shadow: 10px 17px 20px 0px rgba(183, 189, 194, 0.3);
						margin: 0 auto;
						margin-top: 10px;
						opacity: 0;
					}
				}
			}

			.box:nth-child(2)>.top {
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/xiaochengxu02.png) no-repeat;
				background-size: cover;
			}

			.box:nth-child(3)>.top {
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/box3.png) no-repeat;
				background-size: cover;
			}

			.box:nth-child(4)>.top {
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/box4.png) no-repeat;
				background-size: cover;
			}

			.dianshang,
			.weixin,
			.app,
			.wangzhan {
				transform: scale(1.1);

				.buttom {
					background: #ffffff;
					box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.134);

					span {
						color: red;
					}

					.heng {
						opacity: 1;
					}
				}
			}

			.dianshang>.top {
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/dianshang01.png) no-repeat !important;
			}

			.weixin>.top {
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/xiaochengxu01.png) no-repeat !important;
			}

			.app>.top {
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/app01.png) no-repeat !important;
			}

			.wangzhan>.top {
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/wangzhan01.png) no-repeat !important;
			}
		}
	}

	.safety {
		width: 100%;
		height: 1000px;
		background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/anquanbg.png) no-repeat;
		background-size: cover;
		overflow: hidden;

		h3 {
			width: 1000px;
			height: 50px;
			font-size: 36px;
			font-weight: 500;
			color: #000000;
			line-height: 50px;
			margin: 0 auto;
			text-align: center;
			margin-top: 100px;
		}

		p {
			width: 1000px;
			height: 30px;
			font-size: 16px;
			font-weight: 400;
			color: #000000;
			line-height: 30px;
			margin: 0 auto;
			margin-top: 28px;
			text-align: center;
		}

		.content {
			width: 1440px;
			height: 800px;
			margin: 0 auto;
			overflow: hidden;
			display: flex;
			justify-content: space-around;
			// align-items: center;
			margin-top: 80px;
		}

		.box {
			width: 420px;
			height: 525px;
			background: #ffffff;
			border: 1px solid #eeeeee;
			border-radius: 5px;
			overflow: hidden;
			transition: all 0.5s;

			img {
				display: block;
				width: 126px;
				height: 126px;
				margin: 0 auto;
				margin-top: 70px;
			}

			h4 {
				width: 400px;
				height: 36px;
				font-size: 26px;
				font-weight: 500;
				color: #181818;
				line-height: 36px;
				margin: 0 auto;
				text-align: center;
				margin-top: 30px;
			}

			.heng {
				width: 350px;
				height: 1px;
				background: #eeeeee;
				border-radius: 1px;
				margin: 30px auto;
				margin-top: 70px;
			}

			p {
				width: 303px;
				height: 68px;
				font-size: 16px;
				font-weight: 400;
				color: #666666;
				line-height: 26px;
				text-align: center;
				margin: 0 auto;
			}
		}

		.box:hover {
			transform: translateY(80px);
			box-shadow: 7px 11px 12px 0px rgba(232, 236, 242, 0.5000), 0px 2px 0px 0px #FFFFFF;
		}
	}

	.chuangye {
		width: 100%;
		height: 1080px;
		overflow: hidden;

		h3 {
			width: 1000px;
			height: 50px;
			font-size: 36px;
			font-weight: 500;
			color: #000000;
			line-height: 50px;
			margin: 0 auto;
			text-align: center;
			margin-top: 100px;
		}

		p {
			width: 1000px;
			height: 30px;
			font-size: 16px;
			font-weight: 400;
			color: #000000;
			line-height: 30px;
			margin: 0 auto;
			margin-top: 28px;
			text-align: center;
		}

		.content {
			width: 1440px;
			height: 720px;
			margin: 0 auto;
			margin-top: 60px;
			overflow: hidden;
			display: flex;
			flex-wrap: wrap;
			justify-content: space-around;
			align-content: space-around;

			.kaifa {
				width: 690px;
				height: 344px;
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/kaifabg01.png) no-repeat;
				background-size: cover;
				overflow: hidden;
				transition: all 0.5s;

				img {
					display: block;
					width: 50px;
					height: 50px;
					margin: 0 auto;
					margin-top: 60px;
					opacity: 0;
				}

				p {
					width: 100%;
					height: 24px;
					font-size: 24px;
					font-weight: 400;
					color: #ffffff;
					line-height: 36px;
					text-align: center;
				}

				.xian {
					width: 40px;
					height: 4px;
					background: #ffffff;
					margin: 0 auto;
					margin-top: 28px;
				}
			}

			.kaifa:hover {
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/kaifabg02.png) no-repeat;
				background-size: cover;

				img {
					margin-top: 100px;
					opacity: 1;
				}

				p {
					width: 100%;
					height: 34px;
					font-size: 36px;
					font-weight: 500;
					color: #ffffff;
					line-height: 48px;
				}

				.xian {
					opacity: 0;
				}
			}

			.yunkaifa {
				width: 690px;
				height: 344px;
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/yunkaifabg01.png) no-repeat;
				background-size: cover;
				overflow: hidden;
				transition: all 0.5s;

				img {
					display: block;
					width: 50px;
					height: 50px;
					margin: 0 auto;
					margin-top: 60px;
					opacity: 0;
				}

				p {
					width: 100%;
					height: 24px;
					font-size: 24px;
					font-weight: 400;
					color: #ffffff;
					line-height: 36px;
					text-align: center;
				}

				.xian {
					width: 40px;
					height: 4px;
					background: #ffffff;
					margin: 0 auto;
					margin-top: 28px;
				}
			}

			.yunkaifa:hover {
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/yunkaifabg02.png) no-repeat;
				background-size: cover;

				img {
					margin-top: 100px;
					opacity: 1;
				}

				p {
					width: 100%;
					height: 34px;
					font-size: 36px;
					font-weight: 500;
					color: #ffffff;
					line-height: 48px;
				}

				.xian {
					opacity: 0;
				}
			}

			.cesi {
				width: 453px;
				height: 328px;
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/cesibg01.png) no-repeat;
				background-size: cover;
				overflow: hidden;
				transition: all 0.5s;

				img {
					display: block;
					width: 50px;
					height: 50px;
					margin: 0 auto;
					margin-top: 60px;
					opacity: 0;
				}

				p {
					width: 100%;
					height: 24px;
					font-size: 24px;
					font-weight: 400;
					color: #ffffff;
					line-height: 36px;
					text-align: center;
				}

				.xian {
					width: 40px;
					height: 4px;
					background: #ffffff;
					margin: 0 auto;
					margin-top: 28px;
				}
			}

			.cesi:hover {
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/cesibg02.png) no-repeat;
				background-size: cover;

				img {
					margin-top: 100px;
					opacity: 1;
				}

				p {
					width: 100%;
					height: 34px;
					font-size: 36px;
					font-weight: 500;
					color: #ffffff;
					line-height: 48px;
				}

				.xian {
					opacity: 0;
				}
			}

			.fabu {
				width: 453px;
				height: 328px;
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/fabubg01.png) no-repeat;
				background-size: cover;
				overflow: hidden;
				transition: all 0.5s;

				img {
					display: block;
					width: 50px;
					height: 50px;
					margin: 0 auto;
					margin-top: 60px;
					opacity: 0;
				}

				p {
					width: 100%;
					height: 24px;
					font-size: 24px;
					font-weight: 400;
					color: #ffffff;
					line-height: 36px;
					text-align: center;
				}

				.xian {
					width: 40px;
					height: 4px;
					background: #ffffff;
					margin: 0 auto;
					margin-top: 28px;
				}
			}

			.fabu:hover {
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/fabubg02.png) no-repeat;
				background-size: cover;

				img {
					margin-top: 100px;
					opacity: 1;
				}

				p {
					width: 100%;
					height: 34px;
					font-size: 36px;
					font-weight: 500;
					color: #ffffff;
					line-height: 48px;
				}

				.xian {
					opacity: 0;
				}
			}

			.yunying {
				width: 453px;
				height: 328px;
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/001.png) no-repeat;
				background-size: cover;
				overflow: hidden;
				transition: all 0.5s;

				img {
					display: block;
					width: 50px;
					height: 50px;
					margin: 0 auto;
					margin-top: 60px;
					opacity: 0;
				}

				p {
					width: 100%;
					height: 24px;
					font-size: 24px;
					font-weight: 400;
					color: #ffffff;
					line-height: 36px;
					text-align: center;
				}

				.xian {
					width: 40px;
					height: 4px;
					background: #ffffff;
					margin: 0 auto;
					margin-top: 28px;
				}
			}

			.yunying:hover {
				background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/yunyingbg02.png) no-repeat;
				background-size: cover;

				img {
					margin-top: 100px;
					opacity: 1;
				}

				p {
					width: 100%;
					height: 34px;
					font-size: 36px;
					font-weight: 500;
					color: #ffffff;
					line-height: 48px;
				}

				.xian {
					opacity: 0;
				}
			}
		}
	}

	.liucheng {
		width: 100%;
		height: 800px;
		background: #f3f3f5;
		overflow: hidden;

		h3 {
			width: 1000px;
			height: 50px;
			font-size: 36px;
			font-weight: 500;
			color: #000000;
			line-height: 50px;
			margin: 0 auto;
			text-align: center;
			margin-top: 100px;
		}

		p {
			width: 1000px;
			height: 30px;
			font-size: 16px;
			font-weight: 400;
			color: #000000;
			line-height: 30px;
			margin: 0 auto;
			margin-top: 28px;
			text-align: center;
		}

		.content {
			width: 1440px;
			height: 600px;
			margin: 0 auto;
			overflow: hidden;

			img {
				display: block;
				width: 1410px;
				height: 465px;
				margin: 0 auto;
				margin-top: 40px;
			}
		}
	}

	.youshi {
		width: 1440px;
		height: 800px;
		margin: 0 auto;
		display: flex;
		justify-content: space-around;
		align-items: center;

		img {
			display: block;
			width: 620px;
			height: 620px;
		}

		.left {
			width: 620px;
			height: 620px;
			overflow: hidden;

			h3 {
				margin-top: 120px;
				width: 100%;
				height: 50px;
				font-size: 40px;
				font-weight: 500;
				color: #000000;
				line-height: 50px;
			}

			p {
				width: 100%;
				height: 60px;
				font-size: 16px;
				font-weight: 400;
				color: #333333;
				line-height: 30px;
				margin-top: 20px;
			}

			a {
				display: block;
				width: 180px;
				height: 48px;
				line-height: 48px;
				text-align: center;
				font-size: 16px;
				font-weight: 400;
				color: #ffffff;
				background: red;
				border-radius: 30px;
				margin-top: 50px;
			}
		}
	}

	.cases {
		width: 100%;
		height: 825px;
		background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/casebg1.png) no-repeat;
		background-size: cover;
		overflow: hidden;

		.content {
			width: 1440px;
			height: 825px;
			margin: 0 auto;
			overflow: hidden;
			display: flex;
			justify-content: space-around;

			.left {
				width: 500px;
				height: 100%;
				overflow: hidden;

				h3 {
					width: 500px;
					height: 50px;
					font-size: 40px;
					font-weight: 500;
					color: #000000;
					line-height: 50px;
					margin-top: 200px;
				}

				p {
					width: 416px;
					height: 46px;
					font-size: 16px;
					font-weight: 400;
					color: #000000;
					line-height: 30px;
					margin-top: 30px;
				}

				a {
					display: block;
					width: 200px;
					height: 30px;
					line-height: 30px;
					margin-top: 100px;
					font-weight: 500;
					color: #333333;
					font-size: 16px;

				}
			}

			.right {
				width: 900px;
				height: 100%;
				display: flex;
				justify-content: space-between;
				align-items: center;

				img {
					display: block;
					width: 288px;
					height: 607px;
				}
			}
		}
	}

	.apply {
		width: 100%;
		height: 386px;
		background: url(https://junhe.oss-cn-beijing.aliyuncs.com/newgw/xcx/static/lanbg1.png) no-repeat;
		background-size: cover;
		overflow: hidden;

		h3 {
			width: 100%;
			height: 37px;
			font-size: 36px;
			font-weight: 500;
			color: #ffffff;
			line-height: 30px;
			text-align: center;
			margin: 0 auto;
			margin-top: 97px;
		}

		p {
			width: 342px;
			height: 18px;
			font-size: 18px;
			font-weight: 400;
			color: #ffffff;
			line-height: 30px;
			text-align: center;
			margin: 0 auto;
			margin-top: 20px;
		}

		a {
			display: block;
			width: 210px;
			height: 60px;
			background: rgba(255, 255, 255, 0.9);
			box-shadow: 10px 17px 20px 0px rgba(255, 255, 255, 0.1),
				0px 1px 0px 0px #ffffff;
			border-radius: 30px;
			margin: 0 auto;
			margin-top: 90px;
			font-size: 18px;
			font-weight: 500;
			color: #00003e;
			text-align: center;
			line-height: 60px;
		}
	}
</style>
